"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.flexSpaceBetweenStyles = void 0;
var tslib_1 = require("tslib");
var emotion_1 = require("emotion");
exports.flexSpaceBetweenStyles = (0, emotion_1.css)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"], ["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"])));
var templateObject_1;
